module.exports = __webpack_public_path__ + "static/icon-512x512-827f4a38a70c56bf687155851b07af05.png";